module.exports = __webpack_public_path__ + "img/nature-57.750061fd.jpg";